import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { OccupationControllerService } from "../../services";

// Hook to get all scope and occupation
export const useGetAllScope = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_SCOPE];

  const query = useQuery(queryKey, () =>
    handleRequest(
      OccupationControllerService.occupationControllerGetOccupation()
    )
  );

  return {
    ...query,
  };
};
